import React from 'react';
import  Spinner from '../../common/components/spinner/Spinner';

const LoaderComponent = ({loadingIndicator}) => {    
    return(      
        loadingIndicator ? <Spinner/> :null
    );
}

export default LoaderComponent;